import { AlertConfigurationForm } from "../../alertsConfigurationV2/schemas/alertConfigurationSchema";
import { useModalStatusMessage } from "@/hooks";
import { useLingui } from "@lingui/react";
import { msg } from "@lingui/macro";
import { useMutation } from "@apollo/client";
import { transformFormInputToAlertNotificationConfigurationInput, transformFormInputToCreateAlertConfigurationInput,  } from "../utils/inputMapper";
import { CREATE_ALERT_CONFIGURATION } from "../graphql/mutations/createAlertConfiguration";
import GET_DEVICES from "../graphql/queries/getDevices";



export const useCreateAlertConfiguration = () => {
  const { _ } = useLingui();
  const { openModalSuccessMessage, openModalErrorMessage } = useModalStatusMessage();

  const [mutate, { loading }] = useMutation(CREATE_ALERT_CONFIGURATION, {
    refetchQueries: [
      { query: GET_DEVICES }
    ],
    awaitRefetchQueries: true,
    onCompleted() {
      openModalSuccessMessage(_(msg`Configuración de alerta creada correctamente`));
    },
    onError(error) {
      openModalErrorMessage(
        _(msg`Error al crear la configuración de alerta: ${error.message}`)
      );
    },
  });

  const onSubmit = async (data: AlertConfigurationForm) => {
    const alertConfigurationsInput = transformFormInputToCreateAlertConfigurationInput(data);
    try {
      const result = await mutate({ variables: { configurationInput: alertConfigurationsInput } });
      return !!result.data;
    } catch (error: any) {
      console.error('Error creating alert configuration:', error.stack);
      return false;
    }
  };

  return {
    onSubmit,
    loading
  };
}